// ============================================================================
// SUDOKU SOLVER - ALGORITHM METADATA
// ============================================================================

export const meta = {
  id: 'sudoku-solver',
  name: 'Sudoku Solver',
  category: 'Backtracking',
  complexity: {
    time: 'O(9^m)',
    space: 'O(81)'
  },
  description: 'Sudoku Solver solves 9×9 Sudoku puzzles using backtracking to fill empty cells with digits 1-9.'
};
export type MetaType = typeof meta;
